import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview-metrics" }
const _hoisted_2 = { class: "metric-block" }
const _hoisted_3 = {
  class: "metric-num",
  style: {"margin-bottom":"0px"}
}
const _hoisted_4 = ["id"]

import { getConnectorStat } from '@/api/operation'
import useI18nTl from '@/hooks/useI18nTl'
import { usePieChart, MetricType } from '@/hooks/useMetrics'

import { ConnectorState } from '@/types/types'
import useSyncPolling from '@/hooks/useSyncPolling'
// import { MetricsDataWithExtraData } from '@/types/common'
import { ref } from 'vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'ConnectorStatePie',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  operatorId: {
    type: String,
    required: false,
    default: '0',
  },
},
  setup(__props) {

const props = __props

// import { formatNumber } from '@/common/tools'
const { t, tl } = useI18nTl('Dashboard')



const setChartId = (name: string) => {
  return `pie-chart-${name}`
}
const { updatePieData } = usePieChart()

const isLoading = ref(false)
const all = ref(0)
const abnormal = ref(0)
const offline = ref(0)
const working = ref(0)
const idle = ref(0)
const updateToView = async () => {
  try {
    isLoading.value = true

    const data = await getConnectorStat({ operatorID: props.operatorId })

    all.value = 0
    abnormal.value = 0
    offline.value = 0
    working.value = 0
    idle.value = 0

    data.stats.forEach((stat: any) => {
      if (stat.state === ConnectorState.CS_Available) {
        idle.value += stat.num
      } else if (stat.state === ConnectorState.CS_Faulted) {
        abnormal.value += stat.num
      } else if (stat.state === ConnectorState.CS_Unavailable) {
        offline.value += stat.num
      } else {
        working.value += stat.num
      }
      all.value += stat.num
    })

    let showdata = []
    showdata.push(
      {
        name: tl('idle'),
        value: idle.value,
        type: MetricType.Green,
      },
      {
        name: tl('working'),
        value: working.value,
        type: MetricType.Purple,
      },
      {
        name: tl('abnormal'),
        value: abnormal.value,
        type: MetricType.Red,
      },
      {
        name: tl('offline'),
        value: offline.value,
        type: MetricType.Gray,
      },
    )
    updatePieData(`pie-chart-charger`, showdata)
  } catch (error) {
    //
  } finally {
    isLoading.value = false
  }
}

const initMetrics = async () => {
  updateToView()
}

const { syncPolling } = useSyncPolling()
updateToView()
syncPolling(initMetrics, 300000)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, {
        gutter: 24,
        class: "block-bd stats-numbers flow-node-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "metric-pie" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: { name: 'evses' } }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_unref(tl)('viewCharger')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(all.value), 1),
                  _createElementVNode("div", {
                    class: "pie-container",
                    id: setChartId('charger')
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})